// Libs
import React from 'react';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import IconButtonStyled from '../iconButtonStyles';
import Icon from './Icon';

const ListIcon = ({ button, onClick, selected }) => {
	const { theme } = useTheme();

	const fill = React.useMemo(
		() => (selected ? theme._highEmphasisColor : theme._mediumEmphasisColor),
		[selected, theme],
	);

	if (button) {
		return (
			<IconButtonStyled disableRipple onClick={onClick}>
				<Icon fill={fill} />
			</IconButtonStyled>
		);
	}

	return <Icon fill={fill} onClick={onClick} />;
};

export default ListIcon;
